import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';
import { SpecName } from '../models/spec-name.model';

@Component({
    selector: 'excel-sheets-examples',
    templateUrl: './excel-sheets-examples.component.html',
    styleUrls: ['./excel-sheets-examples.component.css']
})
export class ExcelSheetsExamplesComponent implements OnInit {

    public sheets: any[] = [];

    public fileToUpload: File = null;

    public myFile = null;

    public errorOverLay = null;

    constructor(private automationService: AutomationService) { }

    public ngOnInit() {

        this.listExcelSheets();
    }

    public listExcelSheets() {

        this.automationService.registerSpinner.next(true);

        this.automationService.listExcelSheetsExamples()
            .subscribe((sheets) => {

                this.sheets = sheets ? sheets.files : [];

                this.automationService.registerSpinner.next(false);
            }, () => {

                this.automationService.registerSpinner.next(false);
            });
    }

    public addNewExcelSheets() {

        if (this.isValidFile()) {

            this.automationService.registerSpinner.next(true);

            this.automationService.addExcelSheetAsExample(this.fileToUpload)
                .subscribe(() => {

                    this.automationService.registerSpinner.next(false);

                    this.listExcelSheets();
                }, (error) => {

                    if (error.json) {

                        this.errorOverLay = {
                            message: error.json().message
                        };
                    }

                    this.automationService.registerSpinner.next(false);
                });

            this.myFile = null;
        } else {

            this.myFile = null;

            this.errorOverLay = {
                message: 'not an excel sheet'
            };
        }
    }

    public removeExcelSheet(sheetName: string) {

        this.automationService.registerSpinner.next(true);

        this.automationService.removeExcelSheet(sheetName)
            .subscribe(() => {

                this.sheets.splice(this.sheets.indexOf(sheetName), 1);

                this.automationService.registerSpinner.next(false);

            }, (error) => {

                if (error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }

                this.automationService.registerSpinner.next(false);
            });
    }

    public downloadExcelSheet(sheetName: string) {

        this.automationService.registerSpinner.next(true);

        this.automationService.downloadExcelSheet(sheetName)
            .subscribe(() => {

                this.automationService.registerSpinner.next(false);
            }, (error) => {

                if (error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }

                this.automationService.registerSpinner.next(false);
            });
    }

    fileChange(file) {

        this.fileToUpload = file;
    }

    isValidFile(): boolean {

        const fileName = this.fileToUpload.name;

        return fileName.indexOf('.xlsx') > 0 && fileName.indexOf('.xls') > 0;
    }

    closeOverLay() {

        this.errorOverLay = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/excel-sheets-examples/excel-sheets-examples.component.ts